module.exports = __webpack_public_path__ + "images/directory/featured-hero/bitbucket.1d9ccaae3389c020aaa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/bitbucket.jpg
// module id = 9b29
// module chunks = 0